'use client';

import { LeadForm } from './lead-form';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

export default function LeadFormPage() {
  const navigate = useNavigate();
  const { communityId } = useParams<{ communityId: string }>();
  const [searchParams] = useSearchParams();

  const handleCancel = () => {
    if (searchParams.has('memberId') || searchParams.get('from') === 'members') {
      navigate(`/${communityId}/members`);
    } else {
      navigate(`/${communityId}/create`);
    }
  };

  const handleSubmit = (postId: string) => navigate(`/${communityId}/dashboard?postid=${postId}`);

  return (
    <div className="w-full min-w-0 max-w-5xl mx-auto px-0 md:px-4 py-0 md:py-6 overflow-x-hidden">
      <LeadForm onCancel={handleCancel} onSubmit={handleSubmit} />
    </div>
  );
}
